<script setup>
/**
 * FormControlProductOptionsProductTypeId
 * Composition-based wrapper around the One-to-Many Relationship control.
 * Structural Lockout: Evaluates product category mappings on mount, hiding
 * its layout selector element if a root Type ID assignment has already been set.
 */
import {onMounted} from 'vue'
import FormControlTypeRelationshipOneToMany from '@/common/form-control-type/FormControlTypeRelationshipOneToMany.vue'

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

// --- Lifecycle ---

onMounted(() => {
    /**
     * Data Integrity Lock: If this record is already bound to a Product Type,
     * instantly drop visibility from the orchestration layout to prevent manual shifts.
     */
    if (props.currentData?.productTypeId && props.field) {
        props.field.readonly = true
    }
})
</script>

<template>
    <FormControlTypeRelationshipOneToMany v-bind="$props" v-if="!field.hidden"/>
</template>